import request from "@/utils/request";

export function getBanners(params) {
  return request({
    url: "/api/admin/banners/",
    method: "get",
    params,
  });
}
export function getBannerById(bannerId) {
  return request({
    url: `/api/admin/banners/${bannerId}/`,
    method: "get",
  });
}
export function createBanner(data) {
  return request({
    url: `/api/admin/banners/`,
    method: "post",
    data,
  });
}
export function deleteBanner(bannerId) {
  return request({
    url: `/api/admin/banners/${bannerId}/`,
    method: "delete",
  });
}
export function updateBanner(bannerId, data) {
  return request({
    url: `/api/admin/banners/${bannerId}/`,
    method: "patch",
    data,
  });
}
